import {
  KEY_PREFIXES_TO_KEEP_ON_LOGOUT,
  KEYS_TO_KEEP_ON_LOGOUT,
} from "constants/CommonConstants";

export function getLocalStorageItem(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    console.log(error);
    return null;
  }
}

export function setLocalStorageItem(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.log("Local storage is full.");
  }
}

export function removeLocalStorageItem(key) {
  localStorage.removeItem(key);
}

export const shouldKeepOnLogout = (key) =>
  KEYS_TO_KEEP_ON_LOGOUT.includes(key) ||
  KEY_PREFIXES_TO_KEEP_ON_LOGOUT.some((prefix) => key.startsWith(prefix));
